<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on, attrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="attrs"
        :parent-on="on"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
      />
    </template>

    <v-card>
      <v-card-title class="headline">Are you sure you want to delete selected items?</v-card-title>
      <v-card-text />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="onDelete"
          aria-label="Delete"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { getErrorMessage } from '@/main'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    objectType: {
      type: String,
      default: null,
    },
    noServerDelete: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
      required: false,
    },
  },

  methods: {
    onDelete() {
      function deleteItem(item) {
        let url = `${this.apiUrl}`
        if (this.objectType) url += `/${this.objectType}`
        url += `/${item.id}`
        this.$axios
          .delete(url)
          .then(() => {
            this.$emit('itemDeleted', item)
          })
          .catch((error) => (this.message = getErrorMessage(error)))
      }

      for (let i = this.items.length - 1; i >= 0; i--) {
        if (this.noServerDelete) {
          this.$emit('itemDeleted', this.items[i])
        } else {
          deleteItem.call(this, this.items[i], i === 0)
        }
      }

      this.dialog = false
    },
  },
}
</script>
